import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../service/dashboard/dashboard.service';
import {DownloadDocumentService} from "../service/download-document/download-document.service";
import {environment} from "../../environments/environment";
import {NasabahModel} from "../service/model/dashboard.model";
import {DraftService} from "../service/save-draft/save-draft.service";

@Component({
  selector: 'app-insured-summary',
  templateUrl: './insured-summary.component.html',
  styleUrls: ['./insured-summary.component.css']
})
export class InsuredSummaryComponent {

  public summary: any = {};
  public isLoading = [false, false, false, false];
  public todayDate: Date = new Date();
  public selectedItem: any;
  private referenceNo: string;
  public partnerId: string;
  public isEligibleEndorse: boolean = false;
  public ratio : number = 0
  public nasabah: NasabahModel = {
    nasabahUw: {},
    nasabahNewCovering: {},
    nasabahCalculator: {}
  }
  tandaTangan: any;
  login: any;


  constructor(private location: Location,
              private activatedRoute: ActivatedRoute,
              private dashboardService: DashboardService,
              private downloadDocumentService: DownloadDocumentService,
              private router: Router,
              private draftService: DraftService
  ) {
    let background = document.getElementById("background");
    if (background != null) {
      background.className = "allianz-background-faded"
    }

    let jsonSelectedItem = localStorage.getItem('selected-item')
    if (jsonSelectedItem) {
      this.selectedItem = JSON.parse(jsonSelectedItem)
    }
    this.referenceNo = this.activatedRoute.snapshot.paramMap.get('referenceNo') || "";
    this.partnerId = this.activatedRoute.snapshot.paramMap.get('partnerCode') || "";

    let jsonLogin = sessionStorage.getItem('login')

    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }


    this.getDraftCover1()
    this.getDraftCover2()
    this.getDraftCover3()
  }

  ngOnInit() {
    if (this.partnerId == environment.partnerIdBSI) {
      this.dashboardService.summary(this.referenceNo, this.partnerId).subscribe(res => {
        this.summary = res;
        this.summary.totalPremium = res.standardPremi + res.extraPremi!
        // this.kontribusiExtra = this.autoUWResult.extraPremium ? this.autoUWResult.extraPremium.toString() : "0"
        // this.kontribusiDasar = this.autoUWResult.standardPremium ? this.autoUWResult.standardPremium.toString() : "0"
        // this.kontribusiTotal = this.autoUWResult.totalPremium ? this.autoUWResult.totalPremium.toString() : "0"
        // this.totalPembiayaan = this.autoUWResult.totalSumAssured ? this.autoUWResult.totalSumAssured.toString() : "0"
        this.ratio = (Number(res.totalPremium) / Number(res.totalSumAssured)) * 100
      })
    } else {
      this.dashboardService.getNasabah(this.referenceNo).subscribe(res => {
        localStorage.setItem("nasabah", JSON.stringify(res))
        this.nasabah = res
        this.setEligibleEndorse()
        this.summary = {
          fullName: res.nasabahNewCovering.fullName,
          dob: res.nasabahNewCovering.dob,
          gender: res.nasabahNewCovering.gender,
          entryAge: res.nasabahNewCovering.entryAge,
          tenure: res.nasabahNewCovering.tenure,
          applicationNo: res.nasabahNewCovering.referenceNo,
          effectiveDate: res.nasabahNewCovering.effectiveDate,
          maturityDate: res.nasabahNewCovering.maturityDate,
          branchDescription: res.nasabahNewCovering.branchDescription,
          loanTypeDesc: res.nasabahNewCovering.productName ?? "SMARTPROTECTION SMBCI Purnabakti",
          totalSumAssured: res.nasabahNewCovering.sumAssured,
          standardPremi: res.nasabahNewCovering.standardPremi,
          extraPremi: res.nasabahNewCovering.extraPremi,
          totalPremium: res.nasabahNewCovering.standardPremi + res.nasabahNewCovering.extraPremi!,
        }
      })
    }
  }

  public back(): void {
    this.router.navigate(['dashboard']);
  }

  public downloadAcceptanceLetter(): void {
    this.isLoading[0] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "ACCEPTANCE"
    }).subscribe(res => {
      this.downloadDocument('Akseptasi', res.document)
      this.isLoading[0] = false;
    })
  }

  public downloadRejectionLetter(): void {
    this.isLoading[0] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "REJECTED"
    }).subscribe(res => {
      this.downloadDocument('Penolakan', res.document)
      this.isLoading[0] = false;
    })
  }

  public downloadBill(): void {
    this.isLoading[1] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "INVOICE"
    }).subscribe(res => {
      this.downloadDocument('Tagihan', res.document)
      this.isLoading[1] = false;
    })
  }

  public downloadRiplay(): void {
    this.isLoading[2] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "RIPLAY"
    }).subscribe(res => {
      this.downloadDocument('RIPLAY', res.document)
      this.isLoading[2] = false;
    })
  }

  public downloadSPAJK(): void {
    this.isLoading[3] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "SPAJK"
    }).subscribe(res => {
      this.downloadDocument('SPAJKP', res.document)
      this.isLoading[3] = false;
    })
  }

  public downloadSPAJKRiplay(): void {
    this.isLoading[3] = true;
    let nasabah: NasabahModel = {
      nasabahUw: {},
      nasabahNewCovering: {},
      nasabahCalculator: {}
    };
    let jsonNasabah = localStorage.getItem("nasabah")
    if (jsonNasabah) {
      nasabah = JSON.parse(jsonNasabah)
    }
    localStorage.setItem("from-dashboard", "true")
    localStorage.setItem("from-insured-summary", JSON.stringify(true))
    localStorage.setItem("new-covering-response", JSON.stringify({
      premiData: JSON.stringify({
        netPremi: nasabah.nasabahNewCovering.standardPremi
      })
    }))
    this.router.navigate(['eform/spajk-riplay'])
  }

  public downloadRiplayUnsigned(): void {
    this.isLoading[2] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "RIPLAYU"
    }).subscribe(res => {
      this.downloadDocument('RIPLAYU', res.document)
      this.isLoading[2] = false;
    })
  }

  public downloadSPAJKUnsigned(): void {
    this.isLoading[3] = true;
    this.downloadDocumentService.downloadDocument({
      referenceNo: this.referenceNo,
      docType: "SPAJKU"
    }).subscribe(res => {
      this.downloadDocument('SPAJPKU', res.document)
      this.isLoading[3] = false;
    })
  }

  downloadDocument(filename: string, base64: string | undefined) {
    if (base64) {
      const link = document.createElement("a")
      link.href = 'data:application/octet-stream;base64,' + base64;
      link.download = 'Surat ' + filename + ' ' + this.referenceNo + this.extensionFile(base64)
      link.click()
      link.remove()
    } else {
      alert("Dokumen belum tersedia")
    }
  }

  public changeEffectiveDate(): void {
    this.router.navigate(['dashboard/endorse'])
  }

  extensionFile(base64: string) {
    const magicNumbers = {
      'JVBERi': '.pdf',
      'iVBORw': '.png',
      '/9j': '.jpg'
    }

    const firstFewChars = base64.substring(0, 10);
    for (const signature in magicNumbers) {
      if (firstFewChars.startsWith(signature)) {
        return magicNumbers[signature]
      }
    }
    return ".pdf"
  }

  setEligibleEndorse() {
    let subDate30Days = new Date(Date.parse(this.selectedItem.submissionDate))
    subDate30Days.setDate(subDate30Days.getDate() + 30)

    let dateDiffMilliSec = subDate30Days.getTime() - this.todayDate.getTime();
    let dateDiff = Math.ceil(dateDiffMilliSec / (1000 * 60 * 60 * 24))
    //if submission date is more than 30 days then disable button

    this.isEligibleEndorse = dateDiff < 0 || this.nasabah.nasabahNewCovering.endorsementAttempt == "Y"
  }

  getDraftCover1() {
    this.draftService.getDraft({
      userId: this.login.userid,
      pageId: "draftCover1",
      partnerId: this.login.partnerId,
      productCode: this.selectedItem.productCode,
      referenceNo: this.selectedItem.referenceNo
    }).subscribe(res => {
      if (res.statusId == 1) {
        localStorage.setItem("data-pribadi", JSON.stringify(
          {
            nik: res.identityNo,
            namaLengkap: res.fullName,
            namaAlias: res.allias,
            statusPerkawinan: res.maritalStatus,
            tempatLahir: res.pob,
            nomorAplikasi: res.applicationNo,
            usia: res.entryAge,
            jenisKelamin: res.gender,
          }
        ))
      }
    })

  }

  getDraftCover2() {
    this.draftService.getDraft({
      userId: this.login.userid,
      pageId: "draftCover2",
      partnerId: this.login.partnerId,
      productCode: this.selectedItem.productCode,
      referenceNo: this.selectedItem.referenceNo
    }).subscribe(res => {
      if (res.statusId == 1) {
        localStorage.setItem("kontak-pribadi", JSON.stringify(
          {
            nomorHPPribadi: res.mobilePhoneNo,
            emailPribadi: res.emailAddress,
            alamatPribadi: res.address,
            kodePosPribadi: res.zipcode,
            provinsiPribadi: res.province,
            kotaPribadi: res.city,
            alamatDomisili: res.addressDomicile,
            kodePosDomisili: res.zipcodeDomicile,
            provinsiDomisili: res.provinceDomicile,
            kotaDomisili: res.cityDomicile,
          }
        ))
      }
    })
  }

  getDraftCover3() {
    this.draftService.getDraft({
      userId: this.login.userid,
      pageId: "draftCover3",
      partnerId: this.login.partnerId,
      productCode: this.selectedItem.productCode,
      referenceNo: this.selectedItem.referenceNo
    }).subscribe(res => {
      if (res.statusId == 1) {
        this.tandaTangan = {
          tempatTandaTangan: res.ttdTempat,
          ttdSales: res.ttdSales,
          ttdCandidate: res.ttdCandidate,
        }
        localStorage.setItem("kontak-kantor", JSON.stringify({
          namaKantor: res.companyName,
          alamatKantor: res.officeAddress,
          kodePosKantor: res.officeZipCode,
          provinsiKantor: res.officeProvince,
          kotaKantor: res.officeCity,
        }))
        localStorage.setItem("tanda-tangan", JSON.stringify(this.tandaTangan))
      }
    })
  }

  protected readonly environment = environment;
}
